import { Alert, Snackbar } from "@mui/material";
import { useWall } from "../App";

const CustomSnackbar = () => {
  const { snackbar, setSnackbar } = useWall();

  const closeSnackbar = () => {
    setSnackbar({
      show: false,
      content: snackbar.content,
      severity: snackbar.severity,
      position: {
        vertical: "top",
        horizontal: "right",
      },
    });
  };
  return (
    <Snackbar
      open={snackbar.show}
      autoHideDuration={6000}
      onClose={closeSnackbar}
      anchorOrigin={{
        vertical: snackbar.position?.vertical || "top",
        horizontal: snackbar.position?.horizontal || "right",
      }}
    >
      <Alert
        onClose={closeSnackbar}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.content}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
